import styled, { css } from 'styled-components';
import { OpenNewWindow16 } from 'ui/icons';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Drawer, DrawerBody, DrawerFooter } from 'ui/workflows/drawer';
import { WF_Z_INDEX } from '../../constants';

export const NodeEditorWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: transparent;
  z-index: ${WF_Z_INDEX.SIDEBAR};
`;

/* POSITIONING CONTAINER */
export const StyledDrawer = styled(Drawer)`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  z-index: ${WF_Z_INDEX.SIDEBAR};
`;

export const StyledDrawerBody = styled(DrawerBody)`
  position: relative;
  ${({ noPadding }) => (noPadding ? 'padding: 0 0;' : '')}
`;

export const MainDrawer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

/* HEADER */

export const HeaderNodeDetails = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  > * {
    margin-right: ${spacing.threeQuarter};
  }
`;

export const IconContainer = styled.div`
  align-items: center;
  border-radius: ${pxToRem(6)};
  display: flex;
  flex-shrink: 0;
  height: ${pxToRem(45)};
  justify-content: center;
  width: ${pxToRem(45)};
  background: ${({ color }) => color};
`;

export const StyledOpenNewWindowIcon = styled(OpenNewWindow16)`
  margin-left: ${spacing.half};
`;

export const StyledDrawerFooter = styled(DrawerFooter)`
  align-items: center;
  justify-content: space-between;
`;

const FooterButtonsStyles = css`
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing.half};
`;

export const StyledButtons = styled.div<{ $alignLeft?: boolean }>`
  ${FooterButtonsStyles}
  display: flex;
  width: 100%;
  flex-direction: ${({ $alignLeft }) => ($alignLeft ? 'row-reverse' : 'row')};
`;

export const StyledDrawerFooterNoChat = styled(DrawerFooter)`
  ${FooterButtonsStyles}
  > :not(:first-child) {
    margin-left: 0;
  }
`;
